<template>
<div id="app">
	<Navbar />

	<div class="section">

		<h2>Upload Reviews</h2><br/>

		<!-- Call to Action section -->
		<textarea id="text">

	</textarea><br/>
		<button @click="store">Store JSON</button>
		<button @click="parseOldReviews">Parse Old Reviews and Store</button>
		<button @click="parseNewReviews">Parse New Reviews</button>
		<button @click="addNewProfsToCourse">Add New Profs to Courses</button>

		<br/>
		<button @click="uploadReviews">Upload</button>
		<button @click="updateStats">Stats</button><br/>
		<button @click="uploadProfessorStats">Upload Professor Stats</button>

		<br/><br/>
		<br/><br/>
		<h2>Delete Course Reviews</h2><br/>
		Course ID: <input type='text' id="courseInput"><br/>
		<button @click="deleteCollection">Delete Reviews</button>


		<br/><br/>
		<br/><br/>
		<h2>Professor Management</h2><br/>
		<button @click="getAllReviews">Get All Reviews</button> <br/>
		<button @click="showReviews">Show Reviews</button>
		<button @click="addProfessors">Add Profesors from Reviews</button>

		<br/><br/>
		<br/><br/>
		<h2>Professor Review Management</h2><br/>
		<button @click="getProfessorIndex">Index Profesors</button>
		<button @click="updateEachReview">Update Each Review with Professor IDs</button> <br/>
		<button @click="updateEachCourse">Update Each Course with Professor IDs</button>

		<br/><br/>
		<br/><br/>
		<h2>Professor Review Management</h2><br/>
		<button @click="sendTestReview">Send Test Review</button>

		<br/><br/>
		<br/><br/>
		<h2>Remake the Database</h2><br/>
		<button @click="deleteAllReviews">Delete all reviews</button>
		<button @click="deleteAllProfessorCourses">Delete all professor courses</button><br/>
		<button @click="resetCourseData">Reset course data</button>
		<button @click="resetProfessorData">Reset professor data</button><br/>
		<button @click="convertOldReview(json[0])">Convert old review</button>
		<button @click="processAll()">Process all</button>

		<br/><br/>
		<br/><br/>
		<h2>Invert Difficulty</h2><br/>
		<button @click="invertDifficulty()">Invert Difficulty</button>
		<button @click="invertDifficultyCourses()">Invert Difficulty Coures</button>


        <br/><br/>
		<br/><br/>
		<h2>Temp Review Management</h2><br/>
		<button @click="moveTempReview('npvtkH9pMFGVtflsvSTE', 'cse333')">Move Temp Review</button>

	</div>

	<Footer />
	</div>
</template>

<script>
	import Navbar from '@/components/navigation/Navbar'
	import Footer from '@/components/navigation/Footer'
	import { firestore } from '@/firebase'

	export default {
		// This is the name of our component
		name: 'UploadPage',

		// This is all of the components that we use
		components: {
			Navbar,
			Footer
		},

		data() {
			return {
				json: null,
				reviews: [],
				professors: []
			}
		},

		firestore: {
			professors: firestore
				.collection("university")
				.doc("uw")
				.collection("professors")
		},


		// Methods that can be bound to our HTML
		methods: {
			store() {
				this.json = JSON.parse(document.getElementById('text').value);
			},

			parseOldReviews() {
				let text = document.getElementById('text').value;
				let json = JSON.parse(text);

				let data = {};

				for(let key in json) {
					let val = json[key];
					let course = val.course;
					delete val.course;

					if(!(course in data)) {
						data[course] = [];
					}

					val.rating = {
						aceability: val.aceability,
						difficulty: val.difficulty,
						overall: val.overall,
						professor: val.professor__1,
						relevance: val.relevance
					}

					// Delete old
					delete val.aceability;
					delete val.difficulty;
					delete val.overall;
					delete val.professor__1;
					delete val.relevance;

					// Privacy
					delete val.permission;
					delete val.email;
					if(val.name === null || val.name == "") {
						val.name = "Anonymous";
					}

					data[course].push(val);
				}

				console.log(data);
				this.json = data;
			},
			async parseNewReviews() {

				let text = document.getElementById('text').value;
				let json = JSON.parse(text);

				let data = {};

				for(let key in json) {
					let val = json[key];

					if (val.course != 'cse331') {
						continue;
					}

					let obj = {
						date: '24-May-20', 					// today's date
						email: val.email,					// this.email
						hours: val.hours, 					// workload.hours
						name: "Anonymous",
						professor: val.professor,
						professors: [],						// TODO
						quarter: val.quarter, 				// this.overall.quarter
						year: val.year,						// this.overall.year

						rating: {
							overall: val.overallRating,
							workload: 3,
							difficulty: val.difficultyRating,
							professor: val.professorRating,
							relevance: val.relevanceRating,
						},


						overall: {
							year: val.year,
							quarter: val.quarter,
							professor: 0, 					// TODO: ???
							grade: val.grade
						},

						workload: {
							hours: val.hours,
							workTags: {
								"Homework": val.hwHours,
								"Tests": val.testHours,
								"Labs": 0,
								"Check-ins": 0,
								"Presentation": 0,
							},
						},

						difficulty: {
							comment: (val.difficultyRating > 3) ? val.difficultyBad : val.difficultyGood
						},

						relevance: {
							jobTags: this.tagArrToMap(val.jobTags),
							skillTags: this.tagArrToMap(val.skillTags)
						},

						professorMetrics: {
							comment: (val.professorRating < 3) ? val.professorBad : val.professorGood,
							qualityTags: this.tagArrToMap(val.professorTags)
						},

						text: val.text,
						tips: val.tips
					}

					if (val.readingHours > 0) {
						obj.workload.workTags["Readings"] = val.readingHours;
					}

					if (val.ohHours > 0) {
						obj.workload.workTags["Office Hours"] = val.ohHours;
					}


					let found = false;
					for (let key in this.professors) {
						let prof = this.professors[key];

						if (prof.name === val.professor.trim()) {

							let profId = prof.professorId;

							if(!prof.coursesTaught.includes(val.course)) {
								prof.coursesTaught.push(val.course);

								firestore.collection('university').doc('uw')
									.collection('professors').doc(profId)
									.update({

									coursesTaught: prof.coursesTaught
								});

								console.log("Added")
							}

							obj.professors.push(profId);

							found = true;
							break;
						}
					}

					if (!found) {

						let newProf = {
							name: val.professor,
							hoursSum: 0,
							coursesTaught: [val.course],
							numReviews: 0,
						};

						// Add a bunch of professors
						firestore.collection('university').doc('uw')
							.collection('professors').add(newProf)
							.then((docRef) => {
								docRef.update({
									professorId: docRef.id
								});

								// Add professor the the review
								obj.professors.push(docRef.id);
							});
					}


					if (val.course in data) {
						data[val.course].push(obj);
					} else {
						data[val.course] = [obj];
					}
				}




				console.log(data);
				this.json = data;
			},
			tagArrToMap(tmp) {
				let arr = tmp.split(',');
				let map = {};
				for (let key in arr) {
					map[arr[key]] = 1;
				}
				return map;
			},
			addNewProfsToCourse() {

				// Let's look at each professor
				for (let key in this.professors) {
					let prof = this.professors[key];

					// Let's look at each
					for (let key2 in prof.coursesTaught) {
						let courseTaught = prof.coursesTaught[key2];

						let course = firestore
							.collection("university").doc("uw")
							.collection("courses").doc(courseTaught);


						course.get().then((courseSnap)=> {

							let tmp = courseSnap.data();
							tmp = tmp.professors || [];

							if (!tmp.includes(prof.professorId)) {

								console.log(`${prof.professorId} (${prof.name}) added to ${course.id}`);

								tmp.push(prof.professorId);
								course.update({
									professors: tmp
								});

							}
						});

					}

				}

			},

			async uploadReviews() {

				// Protects from accidentally uploading duplicates
				//	alert("Aborting! Manually allow uploading")
				//	return;

				function sleep(ms) {
					return new Promise(resolve => setTimeout(resolve, ms));
				}


				for(let course in this.json) {

					console.log("Uploading " + course);
					let reviews = this.json[course];

					for(let index in reviews) {
						let review = reviews[index];
						firestore.collection('university').doc('uw').collection('courses').doc(course).collection('reviews').add(review);
						console.log("Uploading review");

						await sleep(1000); // let's wait a sec
					}
				}

			},
			updateStats() {

				for(let course in this.json) {

					let numReviews = 0;
					let overallRatings = {
						aceability: 0,
						difficulty: 0,
						overall: 0,
						professor: 0,
						relevance: 0,
						workload: 0
					};
					let overallCounts = {
						1: 0,
						2: 0,
						3: 0,
						4: 0,
						5: 0
					};

					let reviews = this.json[course];
					for(let index in reviews) {
						let review = reviews[index];

						overallRatings['aceability'] += review.rating['aceability'];
						overallRatings['difficulty'] += review.rating['difficulty'];
						overallRatings['overall'] += review.rating['overall'];
						overallRatings['professor'] += review.rating['professor'];
						overallRatings['relevance'] += review.rating['relevance'];
						overallRatings['workload'] += review.hours;

						overallCounts[review.rating['overall']]++;
						numReviews++;
					}

					let stats = {
						numReviews: numReviews,
						ratingSums: overallRatings,
						overallCount: overallCounts
					};
					console.log(stats);

					firestore.collection('university').doc('uw').collection('courses').doc(course).update(stats);
					console.log("Uploading stats for " + course);
				}
			},
			deleteCollection() {
				let course = document.getElementById('courseInput').value;

				if (confirm("Do you want to delete the reviews for " + course + "?") && confirm("Are you sure?")) {
					firestore.collection('university').doc('uw')
						.collection('courses').doc(course)
						.collection('reviews').get()
						.then((querySnapshot) => {

						querySnapshot.forEach((doc) => {
							console.log(doc);
							doc.ref.delete();
						});
					});

				}
			},

			getAllReviews() {

				firestore.collection("university").doc("uw").collection("courses").get().then((courseSnap)=> {

					// Iterate through all the courses
					courseSnap.forEach((course) => {

						if (course.id == 'test') {
							return;
						}

						let reviewCollection = firestore.collection("university/uw/courses/" + course.id +"/reviews");

						// Iterate through all the reviews
						reviewCollection.get().then((reviewSnap) => {

							reviewSnap.forEach((review) => {
								let obj = review.data();
								obj.course = course.id;
								this.reviews.push(obj);
							});
						});
					});
				});

			},
			showReviews() {
				document.getElementById('text').value = JSON.stringify(this.reviews);
			},
			addProfessors() {

				if(!confirm("Are you sure you want to add professors? This may cause duplicates!") || !confirm("Are you sure?")) {
					return;
				}

				let professors = {};

				// Extract all the professor information
				for(let key in this.json) {
					let review = this.json[key];
					if(! (review.professor in professors)) {
						professors[review.professor] = {
							name: review.professor,
							coursesTaught: new Set()
						};
					}

					professors[review.professor].coursesTaught.add(review.course);
				}



				// Convert classes set to array
				for (let key in professors) {
					let prof = professors[key];
					prof.coursesTaught = Array.from(prof.coursesTaught);

					console.log(prof);

					// Add a new professors
					firestore.collection('university').doc('uw').collection('professors').add(prof).then((docRef) => {
						docRef.update({
							professorId: docRef.id
						});
					});
				}



			},

			getProfessorIndex() {
				let profIndex = {};
				firestore.collection("university").doc("uw").collection("professors").get().then((profSnap)=> {

					profSnap.forEach((prof) => {
						let obj = prof.data();
						profIndex[obj.name] = obj;
					});

				});
				console.log(profIndex);
				this.json = profIndex;
			},
			updateEachReview() {

				let profIndex = this.json;

				firestore.collection("university").doc("uw").collection("courses").get().then((courseSnap)=> {

					// Iterate through all the courses
					courseSnap.forEach((course) => {

						if (course.id == 'test') {
							return;
						}

						let reviewCollection = firestore.collection("university/uw/courses/" + course.id +"/reviews");

						// Iterate through all the reviews
						reviewCollection.get().then((reviewSnap) => {

							reviewSnap.forEach((review) => {

								let reviewDoc = firestore.doc("university/uw/courses/" + course.id +"/reviews/" + review.id);
								let obj = review.data();

								let profs = obj.professor.split("/");
								for (let index in profs) {
									let prof = profs[index].trim();
									profs[index] = profIndex[prof].professorId;
								}

								console.log(obj);
								console.log(profs);

								reviewDoc.update({
									professors: profs
								});
							});
						});
					});
				});
			},
			updateEachCourse() {
				let profData = this.json;

				let courses = {};
				for (let key in profData) {
					let prof = profData[key];
					prof.coursesTaught.forEach((course) => {
						if (!(course in courses)) {
							courses[course] = [];
						}
						courses[course].push(prof.professorId);
					});
				}


				for (let key in courses) {
					firestore.collection('university').doc('uw').collection('courses').doc(key).update({
						professors: courses[key]
					});
				}

			},

			uploadProfessorStats() {

				let profStats = {};


				for (let reviewIndex in this.json) {
					let review = this.json[reviewIndex];

					let professorIds = review.professors;
					let course = review.course;
					let rating = review.rating;

					// Go to every professor
					professorIds.forEach((profId) => {

						// Make sure that professor exists
						if (! (profId in profStats)) {
							profStats[profId] = {
								numReviews: 0,
								ratingSums: {
									aceability: 0,
									difficulty: 0,
									professor: 0,
									overall: 0,
									workload: 0,
									relevance: 0
								},
								overallCount: {
									1: 0,
									2: 0,
									3: 0,
									4: 0,
									5: 0
								},
								courses: {}
							};
						}

						// Make sure that this course exists for that professor
						let profCourses = profStats[profId].courses;
						if (! (course in profCourses)) {
							profCourses[course] = {
								numReviews: 0,
								ratingSums: {
									aceability: 0,
									difficulty: 0,
									professor: 0,
									overall: 0,
									workload: 0,
									relevance: 0
								},
								overallCount: {
									1: 0,
									2: 0,
									3: 0,
									4: 0,
									5: 0
								}
							}
						}


						// Add to professor overall
						profStats[profId].numReviews++;
						profStats[profId].ratingSums.aceability += rating.aceability;
						profStats[profId].ratingSums.difficulty += rating.difficulty;
						profStats[profId].ratingSums.professor += rating.professor;
						profStats[profId].ratingSums.overall += rating.overall;
						profStats[profId].ratingSums.workload += review.hours;
						profStats[profId].ratingSums.relevance += rating.relevance;
						profStats[profId].overallCount[rating.overall]++;


						// Add to course-specific
						profStats[profId].courses[course].numReviews++;
						profStats[profId].courses[course].ratingSums.aceability += rating.aceability;
						profStats[profId].courses[course].ratingSums.difficulty += rating.difficulty;
						profStats[profId].courses[course].ratingSums.professor += rating.professor;
						profStats[profId].courses[course].ratingSums.overall += rating.overall;
						profStats[profId].courses[course].ratingSums.workload += review.hours;
						profStats[profId].courses[course].ratingSums.relevance += rating.relevance;
						profStats[profId].courses[course].overallCount[rating.overall]++;

					});

				}

				console.log(profStats);

				// Upload to firestore
				for (let profId in profStats) {

					// Get some references to the professor
					let profDoc = firestore.doc("university/uw/professors/" + profId);

					let courses = profStats[profId].courses;
					delete profStats[profId].courses;

					// Add the updated information to the professor
					profDoc.update(profStats[profId]);

					// asdf
					for (let course in courses) {
						firestore.collection("university/uw/professors/" + profId + "/courses").doc(course).set(courses[course]);
					}
				}

			},
			sendTestReview() {
				let obj = {
					date: '24-Feb-20', 					// today's date
					email: "spard@uw.edu",				// this.email
					hours: 8, 							// workload.hours
					name: "Anonymous",
					professor: "Sohamicus Pohamicus", 	// this.professors[this.overall.professor].name
					professors: ["testProf"],			// this.professors[this.overall.professor].professorId
					quarter: 'Winter', 					// this.overall.quarter
					year: 2020, 						// this.overall.year

					rating: {
						overall: 2,
						workload: 2,
						difficulty: 2,
						professor: 2,
						relevance: 2,
					},


					overall: {
						year: 2020,
						quarter: 'Winter',
						professor: 1, 									// course.professors[0] == testProf
						grade: 3
					},

					workload: {
						hours: 8,
						workTags: {
							"Homework": 2,
							"Tests": 3,
							"Labs": 0,
							"Check-ins": 0,
							"Presentation": 4
						},
					},

					difficulty: {
						comment: null
					},

					relevance: {
						jobTags: {
							"Software Engineer": 0,
							"Systems Engineer": 1,
							"Hardware Engineer": 0,
							"Data Scientist": 0,
							"Researcher": 1,
							"Not relevant": 0
						},
						skillTags: {
							"Improved at interviewing": 0,
							"Helped with side projects": 0,
							"Sharpened fundamentals": 1,
							"Highly industry relevant": 0
						}
					},

					professorMetrics: {
						comment: null,
						qualityTags: {
							"Eager to help": 1,
							"Easy grader": 0,
							"Explains concepts easily": 0,
							"Extra credit opportunity": 0,
							"Energetic": 0,
							"Boring lectures": 0,
							"Very demanding": 0,
							"Harsh grader": 0,
							"Hard to follow along": 1,
							"Lots of busy work": 1
						}
					},

					text: "This is overall advice!", 					// this.comments.overallComment
					tips: "This is specific advice..." 					// this.comments.adviceComment
				}

				console.log("Sending: ", obj);

				// lets add the object
				firestore.collection('university/uw/courses/test/reviews').add(obj).then(() => {
					console.log("Sent!");
				});
			},

			deleteAllReviews() {
				if (!confirm("This will delete all data")
					|| !confirm("Are you sure you want to do this?")
					|| !confirm("Are you SURE???")) {
					return;
				}

				//				firestore.collection('university').doc('uw')
				//						.collection('courses').get()
				//						.then((querySnapshot) => {
				//
				//						querySnapshot.forEach((course) => {
				//							course.ref.collection("reviews").get()
				//							.then((querySnapshot2) => {
				//
				//								querySnapshot2.forEach((doc) => {
				//									console.log(doc.id);
				//									doc.ref.delete();
				//								});
				//							});
				//						});
				//				});
			},
			deleteAllProfessorCourses() {
				if (!confirm("This will delete all data")
					|| !confirm("Are you sure you want to do this?")
					|| !confirm("Are you SURE???")) {
					return;
				}

				firestore.collection('university').doc('uw')
					.collection('professors').get()
					.then((querySnapshot) => {

					querySnapshot.forEach((prof) => {
						prof.ref.collection("courses").get()
							.then((querySnapshot2) => {

							querySnapshot2.forEach((doc) => {
								console.log(doc.id);
								doc.ref.delete();
							});
						});
					});
				});
			},
			resetCourseData() {
				if (!confirm("This will reset a course's data")
					|| !confirm("Are you sure you want to do this?")) {
					return;
				}

				firestore.collection('university').doc('uw')
					.collection('courses').get()
					.then((querySnapshot) => {

					querySnapshot.forEach((course) => {

						course.ref.update({
							hoursSum: 0,
							numReviews: 0,

							overallCount: {
								1: 0,
								2: 0,
								3: 0,
								4: 0,
								5: 0
							},

							ratingSums: {
								overall: 0,
								workload: 0,
								difficulty: 0,
								professor: 0,
								relevance: 0,
							},


							jobTags: {
								"Software Engineer": 0,
								"Systems Engineer": 0,
								"Hardware Engineer": 0,
								"Data Scientist": 0,
								"Researcher": 0,
								"Not relevant": 0
							},


							qualityTags: {
								"Eager to help": 0,
								"Easy grader": 0,
								"Explains concepts easily": 0,
								"Extra credit opportunity": 0,
								"Energetic": 0,
								"Boring lectures": 0,
								"Very demanding": 0,
								"Harsh grader": 0,
								"Hard to follow along": 0,
								"Lots of busy work": 0
							},

							skillTags: {
								"Improved at interviewing": 0,
								"Helped with side projects": 0,
								"Sharpened fundamentals": 0,
								"Highly industry relevant": 0
							},

							workDistribution: {
								"Homework": 0,
								"Tests": 0,
								"Labs": 0,
								"Check-ins": 0,
								"Presentation": 0
							}

						});


					});
				});
			},
			resetProfessorData() {
				if (!confirm("This will reset a course's data")
					|| !confirm("Are you sure you want to do this?")) {
					return;
				}

				firestore.collection('university').doc('uw')
					.collection('professors').get()
					.then((querySnapshot) => {

					querySnapshot.forEach((course) => {

						course.ref.update({
							hoursSum: 0,
							numReviews: 0,

							overallCount: {
								1: 0,
								2: 0,
								3: 0,
								4: 0,
								5: 0
							},

							ratingSums: {
								overall: 0,
								workload: 0,
								difficulty: 0,
								professor: 0,
								relevance: 0,
							},


							jobTags: {
								"Software Engineer": 0,
								"Systems Engineer": 0,
								"Hardware Engineer": 0,
								"Data Scientist": 0,
								"Researcher": 0,
								"Not relevant": 0
							},


							qualityTags: {
								"Eager to help": 0,
								"Easy grader": 0,
								"Explains concepts easily": 0,
								"Extra credit opportunity": 0,
								"Energetic": 0,
								"Boring lectures": 0,
								"Very demanding": 0,
								"Harsh grader": 0,
								"Hard to follow along": 0,
								"Lots of busy work": 0
							},

							skillTags: {
								"Improved at interviewing": 0,
								"Helped with side projects": 0,
								"Sharpened fundamentals": 0,
								"Highly industry relevant": 0
							},

							workDistribution: {
								"Homework": 0,
								"Tests": 0,
								"Labs": 0,
								"Check-ins": 0,
								"Presentation": 0
							}

						});


					});
				});
			},
			convertOldReview(oldReview) {
				console.log(oldReview);

				let obj = {

					version: 2,

					date: oldReview.date,
					course: oldReview.course,
					email: null,										// EMAIL NOT PROVIDED in v1
					hours: this.calculateHours(oldReview.hours),
					name: oldReview.name,
					professor: oldReview.professor,
					professors: oldReview.professors,
					quarter: oldReview.quarter,
					year: oldReview.year,

					rating: {
						overall: oldReview.rating.overall,
						workload: oldReview.hours,						// ACEABILITY is opposite of workload
						difficulty: 6 - oldReview.rating.difficulty,
						professor: oldReview.rating.professor,
						relevance: oldReview.rating.relevance,
					},


					overall: {
						year: oldReview.year,
						quarter: oldReview.quarter,
						professor: oldReview.professor,
						grade: null										// GRADE NOT PROVIDED in v1
					},

					workload: {
						hours: this.calculateHours(oldReview.hours),
						workTags: {
							"Homework": 0,
							"Tests": 0,
							"Labs": 0,
							"Check-ins": 0,
							"Presentation": 0
						},
					},

					difficulty: {
						comment: null
					},

					relevance: {
						jobTags: {
							"Software Engineer": 0,
							"Systems Engineer": 0,
							"Hardware Engineer": 0,
							"Data Scientist": 0,
							"Researcher": 0,
							"Not relevant": 0
						},
						skillTags: {
							"Improved at interviewing": 0,
							"Helped with side projects": 0,
							"Sharpened fundamentals": 0,
							"Highly industry relevant": 0
						}
					},

					professorMetrics: {
						comment: null,
						qualityTags: {
							"Eager to help": 0,
							"Easy grader": 0,
							"Explains concepts easily": 0,
							"Extra credit opportunity": 0,
							"Energetic": 0,
							"Boring lectures": 0,
							"Very demanding": 0,
							"Harsh grader": 0,
							"Hard to follow along": 0,
							"Lots of busy work": 0
						}
					},

					text: oldReview.text,
					tips: oldReview.tips
				};


				// Choose the full year format
				let yearOptions = [2020, 2019, 2018, 2017];
				obj.overall.year = yearOptions.indexOf(obj.year);

				let quarterOptions = ["Fall", "Winter", "Spring", "Summer"];
				obj.overall.quarter = quarterOptions.indexOf(obj.quarter);

				console.log(obj);
				return obj;
			},
			calculateHours(oldHours) {
				let arr = [2, 6.5, 10.5, 14.5, 18];
				return arr[oldHours - 1];
			},

			async processAll() {

				function sleep(ms) {
					return new Promise(resolve => setTimeout(resolve, ms));
				}

				let count = 0;
				for (let index in this.json) {
					let review = this.json[index];
					if (!review.email && review.course) {
						count++;
						let obj = this.convertOldReview(review);
						console.log(count + ": ", obj);
						firestore.collection('university/uw/courses/' + review.course + '/reviews').add(obj);
						await sleep(400);
					}
				}
				console.log("total count: " + count);
			},

			invertDifficulty() {
				firestore.collection('university').doc('uw')
					.collection('courses').get()
					.then((querySnapshot) => {

					querySnapshot.forEach((course) => {

						if (course.id == 'cse446') {
							return;
						}

						course.ref.collection("reviews").get()
							.then((querySnapshot2) => {

							querySnapshot2.forEach((doc) => {
								let d = doc.data();
								let rating = d.rating;
								rating.difficulty = 6 - rating.difficulty;
								doc.ref.update({
									rating: rating
								});
							});
						});
					});
				});
			},
			invertDifficultyCourses() {
				firestore.collection('university').doc('uw')
					.collection('professors').get()
					.then((querySnapshot) => {

					querySnapshot.forEach((professor) => {
						let d = professor.data();

						if (d.coursesTaught[0] == 'cse446' || d.coursesTaught[0] == 'cse484') {
							return;
						}

						let ratingSums = d.ratingSums;
						ratingSums.difficulty = 6 * d.numReviews - ratingSums.difficulty;
						professor.ref.update({
							ratingSums: ratingSums
						});


						// Go to the sub cards
						professor.ref.collection('courses').get().then((querySnapshot2) => {


							querySnapshot2.forEach((course) => {
								let e = course.data();
								let ratingSums2 = e.ratingSums;
								ratingSums2.difficulty = 6 * e.numReviews - ratingSums2.difficulty;
								course.ref.update({
									ratingSums: ratingSums2
								});
							});


						});
					});
				});
			},

            moveTempReview(id, course) {
                firestore
                    .collection("university").doc("uw")
                    .collection("reviews").doc(id)
                    .get()
                    .then((snap) => {
                        if (snap.exists) {
                            let data = snap.data();

                            firestore
                                .collection("university").doc("uw")
                                .collection("courses").doc(course)
                                .collection("reviews").doc(id)
                                .set(data)
                                .then(() => {
                                    console.log(`Moved {id} to {course}\reviews`)
                                });
                        }
				});
            }
		}
	}
</script>

<style lang="scss" scoped>
	.section {
		padding: 10px 10%;
	}
</style>
